import React, { useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import Sidebar from './Sidebar';
import NotificationBell from '../NotificationBell';
import { Toaster } from 'sonner';
import { Menu, X } from 'lucide-react';

const MainLayout = () => {
    const { user, loading } = useAuth();
    const [mobileOpen, setMobileOpen] = useState(false);
    const location = useLocation();

    // Close drawer automatically on route change
    React.useEffect(() => {
        setMobileOpen(false);
    }, [location.pathname]);

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-background">
                <div className="spinner" />
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/login" replace />;
    }

    return (
        <div className="min-h-screen bg-background">
            {/* Mobile top bar */}
            <header
                className="md:hidden sticky top-0 z-30 flex items-center justify-between px-4 bg-[#263238] text-white shadow"
                style={{
                    paddingTop: 'env(safe-area-inset-top)',
                    paddingLeft: 'max(1rem, env(safe-area-inset-left))',
                    paddingRight: 'max(1rem, env(safe-area-inset-right))',
                    minHeight: 'calc(56px + env(safe-area-inset-top))'
                }}
                data-testid="mobile-topbar"
            >
                <button
                    onClick={() => setMobileOpen(true)}
                    aria-label="Apri menu"
                    data-testid="mobile-menu-open"
                    className="p-3 -ml-2 active:bg-white/10 rounded"
                >
                    <Menu size={26} />
                </button>
                <h1 className="font-heading text-lg font-bold tracking-tight uppercase">Pezzaioli</h1>
                <NotificationBell variant="dark" />
            </header>

            {/* Mobile backdrop */}
            {mobileOpen && (
                <div
                    className="md:hidden fixed inset-0 bg-black/50 z-40"
                    onClick={() => setMobileOpen(false)}
                    data-testid="mobile-backdrop"
                />
            )}

            <Sidebar
                mobileOpen={mobileOpen}
                onClose={() => setMobileOpen(false)}
            />

            <main className="md:ml-64 min-h-screen">
                <div className="p-4 sm:p-6 md:p-8">
                    <Outlet />
                </div>
            </main>

            <Toaster position="top-right" richColors />
        </div>
    );
};

export default MainLayout;
